import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { postMethod } from "../../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Search from "../../../components/inputs/Search";
import { BasicContext } from "../../../App";
import { BackOfficeContext } from "../BackOffice";
import ClassTypesDropdown from "../../../components/dropdowns/ClassTypesDropdown";
import LoadedRecords from "../../../components/LoadedRecords";
import PassesListTable from "../../../components/passes/PassesListTable";

const PassesList = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR, changeView } = useContext(BasicContext);
    const { passesList, setPassesList } = useContext(BackOfficeContext);
    const [list, setList] = useState(passesList);
    const [loading, setLoading] = useState(true);
    const [selectedPassType, setSelectedPassType] = useState([]);
    const [search, setSearch] = useState("");
    //const [showNOR, setShowNOR] = useState(NOR);
    const [displayNOR, setDisplayNOR] = useState(NOR);

    const getPassesList = async () => {
        const res = await postMethod("/passes-list", { onlyActivePasses: false });
        if (checkServerData(res)) {
            setList(res.data.list);
            setPassesList(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = passesList;
            filterThisList = filterThisList.filter((el) =>
                el.pass_name.toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(passesList);
        }
    };

    const filterList = (e) => {
        const searchForTypes = (type) => {
            let ifPassHasType = false;
            type.forEach((pt) => {
                selectedPassType.forEach((spt) => {
                    if (spt === pt.class_type_code) ifPassHasType = true;
                });
            });

            return ifPassHasType;
        };

        if (selectedPassType.length === 0 || searchForTypes(e.class_types)) return true;
        else return false;
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        if (!passesList) getPassesList();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">{t("loadingData")}</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("passes.passes")}</h1>
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 200, hide: 150 }}
                                    overlay={<Tooltip id={`createNewPassTooltip`}>{t("passes.createNewPass")}</Tooltip>}
                                >
                                    <Button
                                        className="float-end d-inline-block"
                                        variant="outline-primary"
                                        onClick={() =>
                                            changeView({ nav: "passes", sub: "createPass", params: { passID: null } })
                                        }
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-lg-2" />
                                        <span className="d-none d-lg-inline">{t("passes.addPass")}</span>
                                    </Button>
                                </OverlayTrigger>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 mt-3 px-lg-2 ">
                                <ClassTypesDropdown
                                    onChange={(v) => setSelectedPassType(v)}
                                    value={selectedPassType}
                                    multiple
                                    id="passType"
                                    label={t("classes.classesTypes")}
                                />
                            </Col>
                            <Col xs={12} lg={6} className="px-4 my-lg-4 mb-3 px-lg-2 ">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.filter(filterList).length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list.filter(filterList)} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table">
                                            <tbody>
                                                {list
                                                    .filter(filterList)
                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <PassesListTable e={e} />
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list.filter(filterList)} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.filter(filterList).length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button
                                                onClick={() => setDisplayNOR(NOR + displayNOR)}
                                                variant="outline-primary"
                                                className="mb-3"
                                            >
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default PassesList;
